// extracted by mini-css-extract-plugin
export default {"container":"ItemPossibiliti_container__EhLOU","subTitle":"ItemPossibiliti_subTitle__JXsS6","signWrap":"ItemPossibiliti_signWrap__zlxUP","sign":"ItemPossibiliti_sign__YVU+s"};